var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$validateText(_vm.text))?_c('div',{ref:"container",staticClass:"tooltip-html-container",attrs:{"tabindex":"-1"},on:{"blur":(e) => _vm.onBlur(e)}},[_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
            content: _vm.text,
            trigger: 'manual',
            show: _vm.show,
            container: false,
            popperOptions: {
                positionFixed: true,
            }
        }),expression:"{\n            content: text,\n            trigger: 'manual',\n            show: show,\n            container: false,\n            popperOptions: {\n                positionFixed: true,\n            }\n        }"}],staticClass:"tooltip-wrapper",on:{"click":function($event){return _vm.toggleTooltip()}}},[_vm._t("default",function(){return [_c('i',{staticClass:"fa-regular fa-info-circle tooltip-icon"})]})],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }